import CloseIcon from "@mui/icons-material/Close";
import ProductCheckout from "../../assets/images/icons/ProductCheckoutIcon.svg";
import { useHistory } from "react-router";

// Add interface for props
interface ProductCheckoutPopupProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ProductCheckoutPopup({
  onConfirm,
  onCancel,
}: ProductCheckoutPopupProps) {

  const history = useHistory();

  const redirectToSignupPage = () => {
    history.push('/signup');
  }

  return (
    <>
      <div
        className="modal modal__wd modal__wd--submitSellReq fade show barrel-assignment-modal signup-success-modal" // Added 'show'
        id="rejectUserModal"
        tabIndex={-1}
        aria-labelledby="rejectUserModalLabel"
        aria-hidden="false" // Changed from "true" to "false"
        style={{ display: "block" }} // Added to make modal visible
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header flex-row align-items-center justify-content-between">
              <h1 className="modal-title" id="rejectUserModalLabel">
                Continue with Account
              </h1>
              <button
                type="button"
                className="pt-1 p-0 bg-transparent border-0 text-light"
                onClick={onCancel}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <span className="warning-icon-wrapper">
                  <img src={ProductCheckout} alt="Product Checkout icon" />
                </span>
              </div>
              <h2 className="modal-body__title">
                Oops! We Don’t Know You Yet?
              </h2>

              <p className="modal-text">
                You need to be logged in to place an order. Please log in or sign
                up to continue. If you're a new user please <span className="cursor-pointer signup-link" onClick={redirectToSignupPage}>signup</span> here
                
              </p>
            </div>
            <div className="modal-footer">
              <div className=" d-flex justify-content-center gap-2 flex-wrap w-100">
                <button
                  type="button"
                  className="btn secondary-btn px-5"
                  onClick={onCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn primary-btn px-5"
                  onClick={onConfirm} // Added onClick handler
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Added modal backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
}
